const CLEAR_TYPING_DELAY = 5000

export const initialState = new Map()

export const Actions = {
  SET: 'SET',
  UNSET: 'UNSET'
}

export const typingReducer = (state, action) => {
  const { type } = action

  switch (type) {
    case Actions.SET:
      return handleSet(state, action)
    case Actions.UNSET:
      return handleUnset(state, action)
    default:
      throw new Error(`Unknown typing reducer type: ${type}`)
  }
}

// Adds a typer to the state
const handleSet = (state, action) => {
  const { id, userID, name, cb } = action

  const newVal = { id: userID, name }

  if (!state.has(id)) {
    // Create entry in the map
    return new Map(
      state.set(id, [{ ...newVal, timer: setTimeout(cb, CLEAR_TYPING_DELAY) }])
    )
  }

  const old = state.get(id)
  const isItem = obj => obj.id === userID && obj.name === name
  const oldItem = old.find(isItem)
  if (oldItem) {
    // Refresh timer
    clearTimeout(oldItem.timer)
    oldItem.timer = setTimeout(cb, CLEAR_TYPING_DELAY)
    return new Map(state.set(id, old))
  }

  const newArray = [
    ...old,
    { ...newVal, timer: setTimeout(cb, CLEAR_TYPING_DELAY) }
  ]
  return new Map(state.set(id, newArray))
}

// Removes typer from state
const handleUnset = (state, action) => {
  const { id, userID, name } = action

  if (!state.has(id)) {
    return state
  }

  const old = state.get(id)
  const isItem = obj => obj.id === userID && obj.name === name
  const oldItem = old.find(isItem)
  if (!oldItem) {
    return state
  }

  clearTimeout(oldItem.timer)

  // Remove this typer
  const newArray = old.filter(obj => !isItem(obj))
  return new Map(state.set(id, newArray))
}
